import React, { useState } from "react";
import Header from "../../../commons/header/header";
import Footer from "../../../commons/footer/footer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
} from "@mui/material";

const PhdHolder = () => {
  const [selectedTab, setSelectedTab] = useState("phd-completed");

  // Table 1: List of Ph.Ds Completed
  const phdCompleted = [
    {
      id: 1,
      name: "Dr.P.Eswaramoorthi",
      designation: "Professor",
      department: "AGRI",
      year: 2005,
      degree: "M.E., Ph.D.",
    },
    {
      id: 2,
      name: "Dr.S.Aejitha",
      designation: "Professor",
      department: "Chemistry",
      year: 2017,
      degree: "M.Sc., M.Phil., Ph.D.",
    },
    {
      id: 3,
      name: "Dr.K.M.Savithri",
      designation: "Professor",
      department: "BME",
      year: 2018,
      degree: "M.E., Ph.D.",
    },
    {
      id: 4,
      name: "Dr.B.Gowtham",
      designation: "Associate Professor",
      department: "Physics",
      year: 2023,
      degree: "M.Sc., M.Phil., Ph.D.",
    },
    {
      id: 5,
      name: "Dr.V.Gowthaman",
      designation: "Associate Professor",
      department: "IT",
      year: 2025,
      degree: "M.E., Ph.D.",
    },
    {
      id: 6,
      name: "Dr.S.Nancy Priya",
      designation: "Associate Professor",
      department: "AGRI",
      year: 2024,
      degree: "M.E., Ph.D.",
    },
    {
      id: 7,
      name: "Dr.J.Ezra John",
      designation: "Assistant Professor",
      department: "AGRI",
      year: 2022,
      degree: "M.Sc. Ph.D.",
    },
    {
      id: 8,
      name: "Dr.Kayalvizhi M",
      designation: "Associate Professor",
      department: "EEE",
      year: 2022,
      degree: "M.E., Ph.D.",
    },
    {
      id: 9,
      name: "Dr.A.Thirunavukarasu",
      designation: "Associate Professor",
      department: "AI & DS",
      year: 2016,
      degree: "M.E., Ph.D.",
    },
    {
      id: 10,
      name: "Dr.J.K.Ravichandran",
      designation: "Professor",
      department: "Chemistry",
      year: 2012,
      degree: "M.Sc., Ph.D.",
    },
    {
      id: 11,
      name: "Dr.G.Ajithkumar",
      designation: "Assistant Professor",
      department: "Chemistry",
      year: 2022,
      degree: "M.Sc., Ph.D.",
    },
    {
      id: 12,
      name: "Dr.M.Shyamaladevi Thankachi",
      designation: "Assistant Professor",
      department: "Chemistry",
      year: 2019,
      degree: "M.Sc., M.Phil., Ph.D.",
    },
    {
      id: 13,
      name: "Dr.M.Kalyanasundaram",
      designation: "Assistant Professor",
      department: "Mathematics",
      year: 2022,
      degree: "M.Sc., M.Phil., Ph.D.",
    },
    {
      id: 14,
      name: "Dr.K.Kalimuthu",
      designation: "Assistant Professor",
      department: "Tamil",
      year: 2024,
      degree: "M.A., M.Phil., Ph.D.",
    },
    {
      id: 15,
      name: "Dr.N.Siva",
      designation: "Assistant Professor",
      department: "Physics",
      year: 2023,
      degree: "M.Sc., Ph.D.",
    },
    {
      id: 16,
      name: "Dr.V.Meenambigai",
      designation: "Assistant Professor",
      department: "English",
      year: 2022,
      degree: "M.A., M.Phil., Ph.D.",
    },
    {
      id: 17,
      name: "Dr.P.Sankar",
      designation: "Assistant Professor",
      department: "English",
      year: 2023,
      degree: "M.A., M.Phil., Ph.D.",
    },
  ];

  // Table 2: List of Ph.Ds Pursuing
  const phdPursuing = [
    {
      id: 1,
      name: "Mr.T.Vasanthakumar",
      designation: "Assistant Professor",
      department: "CIVIL",
    },
    {
      id: 2,
      name: "Mr.S.Prabhu",
      designation: "Assistant Professor",
      department: "CSE",
    },
    {
      id: 3,
      name: "Mr.M.S.Praveen",
      designation: "Assistant Professor",
      department: "MECH",
    },
    {
      id: 4,
      name: "Mr.N.Durairaj",
      designation: "Assistant Professor",
      department: "MECH",
    },
    {
      id: 5,
      name: "Mrs.M.Shakthipriyanka",
      designation: "Assistant Professor",
      department: "ENGLISH",
    },
  ];

  return (
    <>
      <Header />
      <div className="phd-holder-container">
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          {/* Left side menu */}
          <Box
            flex={{ xs: "none", sm: "0 0 200px" }}
            bgcolor="transparent"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap={1}
            sx={{
              "@media (max-width: 600px)": {
                flex: "0 0 auto",
              },
              "@media (min-width: 600px)": {
                flex: "0 0 200px",
              },
            }}
          >
            <Button
              variant={selectedTab === "phd-completed" ? "contained" : "outlined"}
              onClick={() => setSelectedTab("phd-completed")}
              style={{
                width: "100%",
                color: selectedTab === "phd-completed" ? "#FFF" : "#000",
                borderColor:
                  selectedTab === "phd-completed" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              List Of Ph.Ds
            </Button>
            <Button
              variant={selectedTab === "phd-pursuing" ? "contained" : "outlined"}
              onClick={() => setSelectedTab("phd-pursuing")}
              style={{
                width: "100%",
                color: selectedTab === "phd-pursuing" ? "#FFF" : "#000",
                borderColor:
                  selectedTab === "phd-pursuing" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              List of Ph.Ds Pursuing
            </Button>
          </Box>

          {/* Right side content */}
          <Box flex="1" p={2}>
            {selectedTab === "phd-completed" && (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        S.No.
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Name of the Faculty
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Designation
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Department
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Year of Completion
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Degree
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {phdCompleted.map((data, index) => (
                      <TableRow
                        key={data.id}
                        style={{
                          backgroundColor: index % 2 === 0 ? "white" : "#f1f8e9",
                        }}
                      >
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.id}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.name}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.designation}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.department}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.year}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.degree}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {selectedTab === "phd-pursuing" && (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        S.No.
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Name of the Faculty
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Designation
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "#01366b",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        Department
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {phdPursuing.map((data, index) => (
                      <TableRow
                        key={data.id}
                        style={{
                          backgroundColor: index % 2 === 0 ? "white" : "#f1f8e9",
                        }}
                      >
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.id}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.name}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.designation}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {data.department}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};

export default PhdHolder;